export default __webpack_public_path__ + "assets/ArrowUpRightFromSquare.0014.svg";